"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APP_ID_ATTRIBUTE_PREFIX = exports.AppType = void 0;
var AppType;
(function (AppType) {
    AppType["END_USER"] = "enduser";
    AppType["ADMIN"] = "admin";
})(AppType || (exports.AppType = AppType = {}));
exports.APP_ID_ATTRIBUTE_PREFIX = 'lia-';
//# sourceMappingURL=index.js.map